import React, { useEffect, useReducer, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import { Add, Close } from "@material-ui/icons";
import DeleteOutlineIcon from "@material-ui/icons/Delete";
import { FormControlLabel, Checkbox, MenuItem, Drawer, Select, Button } from "@material-ui/core";
import { PrimaryButton } from "@loanbossinc/component-library";
import _ from "lodash";
import uuidv4 from "uuid/v4";

import SimpleConfirmDialog from "../../Global/ConfirmationDialogs/SimpleConfirmDialog";

import { getSystemAdmins, getAppsAdmins, saveAppsAdmins } from "./appsSettings.store";

const DrawerNav = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
  border-bottom: 1px solid darkgray;
  background: #fff;
`;

const PageHeader = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  align-items: center;
  color: #000000;
  margin-left: 23px;
`;

const EditAppsAdminsDrawer = props => {
  const { getAppsAdmins, getSystemAdmins, appsAdmins, systemAdmins, saveAppsAdmins, onClose, disabled } = props;
  useEffect(() => {
    getAppsAdmins();
    getSystemAdmins();
  }, []);

  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [appsAdminToDelete, setAppsAdminToDelete] = useState(null);

  /*
   * NOTE:  I am so sorry for hackishly forcing an update.  If there is a better way, please tell me.  I suspect there is.
   *        https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
   *        -- Jonathan Byrne 02/02/2022
   */
  const [_ignored, forceUpdate] = useReducer(x => x + 1, 0);

  const addNewAppsAdmin = () => {
    appsAdmins.push({ id: uuidv4() });
    forceUpdate();
  };

  const deleteAppsAdmin = appsAdminId => {
    _.remove(appsAdmins, appsAdmin => appsAdmin.id === appsAdminId);
    forceUpdate();
  };

  return (
    <Drawer anchor="right" open onClose={() => onClose()} className="drawerManage">
      <DrawerNav>
        <div style={{ display: "flex" }}>
          <Close style={{ color: "red" }} onClick={() => onClose()} />
          <PageHeader>Apps Settings</PageHeader>
        </div>
        <PrimaryButton disabled={disabled} label="Save" size="sm" onClick={() => saveAppsAdmins(appsAdmins)} />
      </DrawerNav>
      <div className="sidebarDashboard">
        {appsAdmins &&
          systemAdmins &&
          appsAdmins.map(appsAdmin => (
            <div key={appsAdmin.id} className="settingInner">
              <div className="width-50">
                <Select
                  disabled={disabled}
                  value={appsAdmin.userId}
                  style={{ width: "205px" }}
                  onChange={event => {
                    appsAdmin.userId = event.target.value;
                    forceUpdate();
                  }}
                >
                  {systemAdmins.map(systemAdmin => (
                    <MenuItem key={systemAdmin.id} value={systemAdmin.id}>
                      {`${systemAdmin.contact.firstName} ${systemAdmin.contact.lastName}`}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <FormControlLabel
                disabled={disabled}
                className="manageCheckbox"
                control={<Checkbox
                  checked={appsAdmin.canUpdateSettings}
                  value="adminActive"
                  color="primary"
                  onChange={() => {
                    appsAdmin.canUpdateSettings = !appsAdmin.canUpdateSettings;
                    forceUpdate();
                  }}
                />}
                label="Can Edit Settings"
              />
              <Button
                disabled={disabled}
                onClick={() => {
                  setAppsAdminToDelete(appsAdmin);
                  setConfirmDeleteModalOpen(true);
                }}
              >
                <DeleteOutlineIcon />
              </Button>
            </div>
          ))}
      </div>

      <Button disabled={disabled} onClick={() => addNewAppsAdmin()}>
        <Add />
        Add New Apps Admin
      </Button>

      {confirmDeleteModalOpen &&
        <SimpleConfirmDialog
          modalOpen={confirmDeleteModalOpen}
          title="Confirm Deletion"
          message={"Are you sure?"}
          yesText="Yes, delete"
          noText="No"
          handleNo={() => setConfirmDeleteModalOpen(false)}
          handleYes={() => {
            deleteAppsAdmin(appsAdminToDelete.id);
            setConfirmDeleteModalOpen(false);
          }}
        />}
    </Drawer>
  );
};

const mapStateToProps = ({ authentication, appSettings }) => ({
  authentication,
  appsAdmins: _.cloneDeep(appSettings.appsAdmins),
  systemAdmins: _.sortBy(appSettings.systemAdmins, ["contact.firstName", "contact.lastName"])
});

export default compose(connect(mapStateToProps, { getAppsAdmins, saveAppsAdmins, getSystemAdmins }))(EditAppsAdminsDrawer);
